// COCHE §10.1.10 — English (Hong Kong). Mirror the keys in zh_cn.ts.
export default {
	common: {
		save: "Save",
		cancel: "Cancel",
		delete: "Delete",
		edit: "Edit",
		search: "Search",
		export: "Export",
		import: "Import",
		confirm: "Confirm",
		yes: "Yes",
		no: "No",
		add: "Add",
		back: "Back",
		close: "Close",
		operation: "Operation",
		loading: "Loading…",
		empty: "No data",
		opSuccess: "Operation successful",
		opFailed: "Operation failed",
		submit: "Submit",
		reset: "Reset",
		reload: "Reload",
		view: "View",
		more: "More",
		all: "All",
		tip: "Notice",
		confirmDelete: "Delete this item?",
		pleaseSelect: "Please select",
		loadFailed: "Failed to load",
		downloadSuccess: "Downloaded",
		warning: "Warning",
		operationSuccess: "Done",
		pleaseInput: "Please enter",
		deleteSuccess: "Deleted",
		editSuccess: "Edited successfully",
		addSuccess: "Added successfully",
		viewSource: "OCR source",
		confirmDeleteRecord: "Delete this record?",
		recordSeqHeader: "No.",
		detail: "Details",
		requiredFieldHint: "Missing required fields. Tap submit again to jump to the first one.",
	},
	auth: {
		sessionExpired: "Your session has expired. Please sign in again.",
		permissionDenied: "You don't have permission for this action.",
		networkError: "Can't reach the server. Please check your connection.",
	},
	login: {
		title: "Sign in",
		username: "Username",
		password: "Password",
		submit: "Sign in",
		captcha: "Captcha",
		rememberMe: "Remember me",
		welcome: "Welcome back",
		signIn: "Sign in",
		platformTitle: "Clinical Research Database",
		platformTagline: "Efficient, flexible clinical-research data captured end-to-end.",
		sxswTitle: "Shaanxi Neurosurgery Quality Control Centre — Data Capture System",
		bgAlt: "Background",
		tabPassword: "Password",
		tabSms: "SMS code",
		tabWechat: "WeChat QR",
		usernamePh: "Please enter your username",
		passwordPh: "Please enter your password",
		mobilePh: "Please enter your mobile number",
		smsCodePh: "Please enter the SMS code",
		captchaPh: "Captcha",
		invalidMobile: "Please enter a valid 11-digit mobile number",
		getCode: "Get code",
		resendCode: "Resend in {sec}s",
		smsSent: "SMS code sent successfully",
		copyright: "© 2024 Beijing IMLES Technology Co., Ltd. ICP filing 19052789-1",
		icpFiling: "Beijing PSB filing 11011302007191",
		platformTitleMycoach: "Clinical Data Platform",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. All rights reserved. Compliant with HIPAA and PIPEDA standards.",
	},
	nav: {
		dashboard: "Dashboard",
		patients: "Patients",
		projects: "Projects",
		schema: "Schema",
		governance: "Governance",
		settings: "Settings",
		logout: "Sign out",
	},
	locale: {
		switcher: "Language",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "Schema translation",
			scanProject: "Scan project for gaps",
			draftWithLlm: "Draft with LLM",
			applySelected: "Save selected",
			columnSource: "Source",
			columnSuggestion: "LLM draft",
			columnEdited: "Your edit",
			noMissing: "All schema labels for this project are already translated.",
		},
	},
	imaging: {
		title: "Imaging viewer",
		studies: "Studies",
		series: "Series",
		viewer: "Viewer",
		reload: "Reload",
		loading: "Loading…",
		prev: "Prev",
		next: "Next",
	},
	timeseries: {
		title: "Physiological signals",
		streams: "Streams",
		viewer: "Viewer",
		reload: "Reload",
	},
	encryption: {
		title: "Encryption status",
		enabled: "Enabled",
		disabled: "Disabled",
		mysql: "MySQL",
		reload: "Reload",
		encryptAll: "Encrypt all",
		decryptAll: "Decrypt all",
	},
	header: {
		maskedHospital: "**** Hospital",
		systemAdminConsole: "System Admin Console",
		switchTenant: "Switch Tenant",
		configForm: "Configure Form",
		switchProject: "Switch Project",
		setPassword: "Set Password",
		changePassword: "Change Password",
		avatarSettings: "Avatar Settings",
		settings: "Settings",
		logout: "Sign out",
		oldPassword: "Old password",
		newPassword: "New password",
		confirmPassword: "Confirm password",
		enterOldPassword: "Please enter the old password",
		enterNewPassword: "Please enter the new password",
		enterConfirmPassword: "Please re-enter the new password",
		passwordMismatch: "Passwords do not match",
		tenantCodePrompt: "Enter tenant code (must be a valid tenant code)",
		passwordSetSuccess: "Password set. Please sign in again.",
		passwordChangeSuccess: "Password changed. Please sign in again.",
		compactMode: "Compact mode",
		compactModeDesc: "Form fields laid out horizontally with tighter line spacing",
		darkMode: "Dark mode",
		darkModeDesc: "Local-only; persists across reload",
		dataMasking: "Data masking",
		dataMaskingDesc: "Hide sensitive fields in lists/forms",
		fontTheme: "Font theme",
		fontThemeDesc: "Pick a modern type pairing for English and Chinese — local-only, applies instantly",
		fontThemeModern: "Modern",
		fontThemeEditorial: "Editorial",
		fontThemeFriendly: "Friendly",
		betaSuffix: " (BETA)",
		languageDesc: "Interface language; the page reloads when you switch",
		changePasswordDesc: "Update your sign-in password; you will be signed out after the change",
		avatarSettingsDesc: "Upload or replace your avatar image",
		modify: "Modify",
	},
	followup: {
		title: "Follow-ups",
		statTotalCase: "Total cases",
		statMonthlyDue: "Visits due this month",
		statMonthlyDone: "Visits completed this month",
		statMonthlyOpen: "Visits outstanding this month",
		searchDate: "Visit date:",
		searchStatus: "Status:",
		searchPatient: "Patient name / ID:",
		startDate: "Start",
		endDate: "End",
		select: "Select…",
		input: "Type here",
		searchBtn: "Search",
		resetBtn: "Reset",
		colIndex: "No.",
		colVisitPlan: "Visit plan",
		colPatientName: "Patient",
		colPatientNo: "Patient ID",
		colVisitDate: "Visit date",
		colVisitName: "Visit",
		colStatus: "Status",
		colCenter: "Centre",
		colOperation: "Actions",
		actEdit: "Edit",
		actView: "View",
		actCancel: "Cancel visit",
		statusPending: "Pending",
		statusOverdue: "Overdue",
		statusDone: "Done",
		fieldKeyword: "Type to search",
		detailTitle: "Follow-up detail",
	},
	multicenter: {
		overviewTitle: "Multi-centre overview",
		patientTitle: "Multi-centre patients",
		followupTitle: "Multi-centre follow-ups",
		colCenter: "Centre",
		colTenant: "Tenant",
		colPatientCount: "Patients",
		colFollowupCount: "Follow-ups",
		colCompleteness: "Completeness",
		switchProject: "Switch project",
		statCenters: "Centres",
		statPatients: "Total patients",
		statFollowups: "Total visits",
		statOverdue: "Overdue visits",
		newPatientTrend: "New patient trend",
		today: "Today",
		thisWeek: "This week",
		thisMonth: "This month",
		thisYear: "This year",
		startDate: "Start date",
		endDate: "End date",
		dateSep: "to",
		centerPatientCount: "Patients per centre",
		colRank: "Rank",
		colCenterName: "Centre",
		colUserCount: "Users",
		colPatientCountAlt: "Patients",
		patientGender: "Patient gender",
		mcInfo: "Multi-centre info",
		caseCount: "Cases",
		departmentCount: "Departments",
		mapCenters: "Centre map",
		mapPatients: "Patient distribution",
		caseFilter: "Filter by case count",
		all: "All",
		hospitalName: "Hospital:",
		departmentName: "Department:",
		projectName: "Project:",
		patientCountLabel: "Cases:",
		emptyData: "No data",
	},
	manage: {
		auditLog: "Audit log",
		piiRule: "PII rule config",
		governanceInbox: "Approval inbox",
		myRequests: "My requests",
		scopeTree: "Org chart",
		lifecycle: "Lifecycle",
		metadataVersioning: "Schema versions",
		ingestionHardening: "Ingestion guard",
		subCenter: "Sub-centres",
		schema: "Schema gen",
		agentConfig: "Agent config",
		random: "Randomisation",
	},
	databaseConfig: {
		patientBasicInfo: "Patient basic info",
		databaseSection: "Database configuration",
		followupSection: "Follow-up forms",
		colNo: "No.",
		colFormCode: "Form code",
		colFormName: "Form name",
		colModelCount: "Models",
		colOp: "Actions",
		colFollowupCode: "Follow-up form code",
		colFollowupName: "Follow-up form name",
		colFollowupPlan: "Linked follow-up plan",
		colFollowupPlanName: "Linked plan name",
		btnAdd: "Add",
		btnBatchAdd: "Batch add",
		btnDelete: "Delete",
		btnEdit: "Edit",
		btnConfig: "Configure",
		btnConfigFromTemplate: "From template",
		btnConfigFromForm: "From project form",
		dlgEditTitle: "Edit",
		dlgAddTitle: "Add",
		dlgEditFollowupTitle: "Edit follow-up form",
		dlgAddFollowupTitle: "Add follow-up form",
		dlgFormName: "Form name",
		dlgFollowupName: "Follow-up form name",
		dlgPh: "Please enter",
		dlgCancel: "Cancel",
		dlgConfirm: "Confirm",
	},
	memberPermissions: {
		title: "Members & permissions",
		colNo: "No.",
		colTenant: "Tenant",
		colUsername: "Username",
		colNickname: "Nickname",
		colFuncPermission: "Function permission",
		colDataPermission: "Data permission",
		colActions: "Actions",
		btnConfigure: "Configure",
		btnEdit: "Edit",
		noRolesAssigned: "(no roles)",
		canDelete: "Delete allowed",
		cannotDelete: "No delete",
		scopeCount: "Scope: {f} form(s) · {m} model(s)",
		actEditRoles: "Edit function permission",
		actEditData: "Edit data permission",
		actRemove: "Remove",
		confirmRemove: "Remove this user from the project?",
		dlgAddTitle: "Add member",
		addHint: "Search by exact username, employee number, or mobile to add a member. Set function and data permissions afterwards.",
		searchPh: "Type exact username / employee no / mobile…",
		searchNoMatch: "No matching user — check spelling or use exact ID",
		lblAccount: "Account",
		btnAddAnother: "Add another",
		dlgFuncTitle: "Function permission",
		projectRolesLabel: "Project-scoped roles (managed here)",
		globalRolesLabel: "Globally-effective roles (managed in user admin)",
		globalRolesHint: "These roles are assigned at the user level and apply to every project. Edit them in the user admin page, not here.",
		projectRolesEmptyButGlobal: "No project-scoped roles assigned. This user's effective permissions on this project come entirely from the global roles above. Add a role here to give them additional permissions scoped to this project only.",
		projectRolesEmptyNoGlobal: "No roles assigned to this user yet. Pick one or more above to grant project-scoped access.",
		dlgDataTitle: "Data permission",
		dataBypassModelAdmin: "Heads-up: this user has the Model Administrator role and bypasses the data-permission filter entirely. The selections below are saved but have no effect at view time — they only apply to users without Model Administrator.",
		dataBypassProjectCreator: "Heads-up: this user is the project creator and bypasses the data-permission filter entirely. The selections below are saved but have no effect at view time — project creators always see all forms and models.",
		opPermissionLabel: "Operation permission",
		opRead: "Read-only",
		opModify: "Read + Write",
		deletePermissionLabel: "Delete permission",
		sodWarnTitle: "Separation-of-duties warning ({n} conflicts) — you may still save",
		sodErrorTitle: "Separation-of-duties violation ({n} conflicts) — enforce mode is on, save blocked",
		sodEnforceBlocked: "Separation-of-duties violation — remove the conflicting roles before saving",
		sodWarnSaved: "Saved with {n} separation-of-duties warning(s)",
	},
	sod: {
		tagPending: " (pending)",
		tagAssigned: " (assigned)",
		violationLine: "{a} conflicts with {b} ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "Filter by tenant code",
		visibilityTitle: "My scope visibility",
		visibilityPrompt: "Click Reload to query the current session's visible project set.",
		fUserId: "User ID",
		fBypass: "Bypass filter",
		bypassYes: "Yes (bypass)",
		bypassNo: "No (enforced)",
		fReason: "Reason",
		fScopePaths: "Scope paths",
		noScopePath: "— no scope_path assigned —",
		fAllowedProjects: "Visible project IDs",
		bypassAll: "— bypass: all visible —",
		noVisibleProject: "No visible projects (allowed-set is empty)",
		emptyTree: "No organisation data yet",
		rootLabel: "All organisations",
		tagDefault: "Default",
		tagProjectCount: "{n} project(s)",
		truncated: "Results truncated (>1000 nodes). Use the per-level endpoint to paginate.",
		selectHint: "Select a node on the left to view its details.",
		dKind: "Level",
		dCode: "Code",
		dTenant: "Tenant",
		dRegulatory: "Regulatory jurisdiction",
		dFederation: "Federation mode",
		dAddress: "Address",
		dCountry: "Country",
		dRegion: "Region",
		dMission: "Mission",
		dProjectCount: "Projects",
	},
	auditLog: {
		title: "Audit log",
		refresh: "Refresh",
		startDate: "From",
		endDate: "To",
		category: "Category",
		verb: "Verb",
		targetType: "Target type",
		outcome: "Outcome",
		actorUserId: "Actor ID",
		dataSubjectId: "Data subject ID (GDPR)",
		targetProjectCode: "Project code",
		search: "Search",
		reset: "Reset",
		empty: "No audit logs",
		colTime: "Time",
		colActor: "Actor",
		colApp: "Source",
		colCategory: "Category",
		colVerb: "Verb",
		colTarget: "Target",
		colOutcome: "Outcome",
		colDetail: "Detail",
		view: "View",
		drawerTitle: "Audit log detail",
		eventSection: "Event",
		complianceSection: "Compliance metadata (GDPR readiness)",
		integritySection: "Integrity (hash chain)",
		fId: "ID",
		fTime: "Time",
		fActor: "Actor",
		fIp: "IP",
		fApp: "Source",
		fCategory: "Category / Verb",
		fOutcome: "Outcome",
		fFailureReason: "Failure reason",
		fTarget: "Target",
		fProject: "Project",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "Yes",
		no: "No",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "Linked change record",
		loadChange: "Load change detail",
		fTable: "Table/Collection",
		fPk: "Primary key",
		fOp: "Op",
		loadChangeFailed: "Failed to load change detail",
	},
	metaVer: {
		intro: "Read-only view of <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a>. Version/history snapshots roll out via spec §3's three-phase switches. See <code>extract/coche/specs/metadata-versioning.md</code>.",
		tabLog: "Evaluation log (shadow+exec)",
		tabTags: "Tags",
		tabAdapters: "Format adapters",
		colTarget: "Target",
		colPriorVer: "Prior ver.",
		colNote: "Note",
		colCode: "Code",
		colTag: "Tag",
		colDescription: "Description",
		colCreated: "Created",
		colExtensions: "Extensions",
		colName: "Name",
		colEnabled: "Enabled",
		on: "On",
		off: "Off",
	},
	lifecyclePage: {
		intro: "Read-only view of <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a>. Policies and legal holds are created via the API; execution flows through the approval workflow (§10.1.3). See <code>extract/coche/specs/lifecycle-retention.md</code>.",
		tabPolicies: "Retention policies",
		tabHolds: "Legal holds",
		tabLog: "Evaluation log (shadow+exec)",
		colTargetType: "Target type",
		colRetentionDays: "Retention (d)",
		colAgeAnchor: "Age anchor",
		colAction: "Action",
		colEnabled: "Enabled",
		colDescription: "Description",
		on: "On",
		off: "Off",
		colScope: "Scope",
		colTargetId: "Target ID",
		colReason: "Reason",
		colImposed: "Imposed",
		colReleased: "Released",
		active: "Active",
		colAgeDays: "Age (d)",
		colRequest: "Request",
		colNote: "Note",
	},
	ingestion: {
		intro: "Read-only view. Ingestion hardening rolls out via spec §3's three-phase switches (Phase A=dormant / Phase B=shadow / Phase C=enforce). SFTP server is independently gated by <code>imles.ingestion.sftp.enabled</code>. See <code>extract/coche/specs/ingestion-hardening.md</code>.",
		tabChecksum: "Checksum (SHA-256)",
		tabRejections: "Rejection queue",
		tabDedup: "Dedup table",
		tabSftp: "SFTP sessions",
		hashPlaceholder: "Look up by SHA-256 (64 hex)",
		colOssFile: "OSS file",
		colBytes: "Bytes",
		colSource: "Source",
		colUploaded: "Uploaded",
		colFilename: "Filename",
		colReason: "Reason",
		colMode: "Mode",
		colDetail: "Detail",
		colOriginFileId: "Origin file ID",
		colReuseCount: "Reuse count",
		colFirstSeen: "First seen",
		colLastReuse: "Last reuse",
		colUser: "User",
		colAuth: "Auth",
		colOpened: "Opened",
		colClosed: "Closed",
		colUploads: "Uploads",
		colTotalBytes: "Total bytes",
		colCloseReason: "Close reason",
	},
	dbConfig: {
		title: "Database config",
		step1: "Select database model",
		step2: "Select output type",
		step3: "Configure form/document",
		step4: "Configure fields",
		selectedOutput: "Selected output type",
		structuredForm: "Structured form",
		structuredF1: "· Export data with custom forms",
		advFilter: "· Advanced filtering supported",
		univariate: "· Univariate statistical analysis supported",
		crfExport: "· Generate CRF tables from data, export as PDF/Word",
		defaultForm: "Default form",
		defaultF1: "· Display the form with its default structure",
		formConfigTitle: "Project form config",
		formName: "Project form name",
		formCode: "Project form code",
		formOrder: "Project form order",
		visible: "Visible",
		formModelConfigTitle: "Project form model config",
		selectModel: "Select model",
		newModel: "New model",
		colIndex: "No.",
		modelCode: "Model code",
		modelName: "Model name",
		modelDomain: "Model domain",
		modelOrder: "Model order",
		modelConfigTitle: "Project model config",
		modelNameLabel: "Project model name",
		modelCodeLabel: "*Project model code",
		modelCodeLabelReq: "Project model code",
		dontModify: "Do not modify unless necessary",
		deletionMode: "Deletion mode",
		logical: "Logical",
		physical: "Physical",
		modelDescription: "Model description",
		showNoteInput: "Show note input",
		note: "Note",
		sceneType: "Scene type",
		sceneDefault: "Default scene",
		sceneTable: "Table scene",
		sceneTableDialog: "Table dialog scene",
		sceneList: "List scene",
		uploadAttachment: "Upload attachment",
		on: "On",
		off: "Off",
		saveModelAttrs: "Save model attributes",
		editFields: "Edit fields",
		modelFieldConfigTitle: "Project model field config",
		previous: "Previous",
		next: "Next",
		selectedInfo: "Selected info",
		availableInfo: "Available info",
		codeFormatHint: "Enter letters, digits or underscores",
		selectRowFirst: "Select a row before adding",
		enterModelName: "Enter the project model name",
		enterModelCode: "Enter the project model code",
		modelCodeFormat: "Model code may only contain letters, digits and underscores",
		saveFormFirst: "Save the form info first",
		modelCodeExists: "This model code already exists",
	},
	fieldList: {
		colFieldOrder: "Field order",
		colIntegrityScore: "Integrity score",
		colFieldCode: "Field code",
		colFieldName: "Field name",
		colFieldType: "Field type",
		colVisible: "Visible",
		colEditable: "Editable",
		colRequired: "Required",
		colDictValue: "Dictionary value",
		addField: "Add field",
		refField: "Reference field",
		dlgEdit: "Edit",
		dlgAdd: "Add",
		order: "Order",
		noSorting: "No sorting",
		reservedHint: "The following field codes have special meaning and are auto-mapped to the patient info table:",
		colMeaning: "Meaning",
		colDescription: "Description",
		reservedUniqueNote: "<b>card_id</b>, <b>inpatient_id</b> and <b>outpatient_id</b> have a uniqueness constraint — duplicate values are not allowed within the same project, which helps prevent duplicate patient entry.",
		fieldNameZh: "Field name (Chinese)",
		fieldNameEn: "Field name (English)",
		fieldAlias: "Field alias",
		tailLabel: "Tail label",
		fieldDesc: "Field description",
		controlsVisibility: "Controls visibility",
		controlledFields: "Controlled fields",
		optionCode: "Option code",
		optionName: "Option name",
		controlledFieldCount: "Controlled field count",
		controlledModelCount: "Controlled model count",
		inFormEvent: "In-form event",
		inModelEvent: "In-model event",
		inModelClickEvent: "In-model click event",
		showNoteInput: "Show note input",
		note: "Note",
		subFieldList: "Sub-field list",
		refList: "Reference list",
		selectExisting: "Select existing field",
		colIndex: "No.",
		colModifiedBy: "Modified by",
		colModifiedAt: "Modified at",
		dlgSubEdit: "Edit sub-field",
		dlgSubAdd: "Add sub-field",
		existingFieldList: "Existing field list",
		fieldControlled: "Field-controlled",
		modelControlled: "Model-controlled",
		colFieldId: "Field ID",
		colModelId: "Model ID",
		colModelCode: "Model code",
		colModelName: "Model name",
		refSaved: "Reference relationship saved",
		convertedToSub: "Converted to sub-field",
		none: "None",
		reserved: {
			name: { n: "Name", d: "Patient name" },
			gender: { n: "Gender", d: "0=Female, 1=Male" },
			age: { n: "Age", d: "Patient age" },
			birthday: { n: "Date of birth", d: "Patient birthday" },
			phone: { n: "Mobile", d: "Contact phone" },
			idNum: { n: "ID number", d: "National ID number" },
			cardId: { n: "Admission card no.", d: "Unique constraint, no duplicates" },
			inpatientId: { n: "Outpatient no.", d: "Unique constraint, no duplicates" },
			outpatientId: { n: "Inpatient no.", d: "Unique constraint, no duplicates" },
			admissionTime: { n: "Admission time", d: "Date type" },
			enrollmentTime: { n: "Enrollment time", d: "Date type" },
			diagnosis: { n: "Diagnosis", d: "Diagnosis info" },
			doctorId: { n: "Doctor ID", d: "Linked doctor" },
			doctorName: { n: "Doctor name", d: "Linked doctor name" },
			hospitalName: { n: "Hospital", d: "Hospital name" },
			status: { n: "Patient status", d: "e.g. enrolled, withdrawn" },
			statusCode: { n: "Status code", d: "Code for the status" },
		},
	},
	customColumn: {
		title: "Custom columns",
		searchFieldPh: "Search field name",
		name: "Name",
		order: "Order",
		visible: "Visible",
		description: "Description",
		propertyPath: "Property path",
		selectProperty: "Please select a property",
		colIndex: "No.",
	},
	piiRule: {
		title: "PII rule config",
		currentProject: "Current project",
		refresh: "Refresh",
		readonly: "Read-side anonymisation",
		readonlyDesc: "Rules only apply on data export and cohort search paths; stored data is untouched. KEEP returns the raw value. Roles with the pii.unmask permission can bypass (bypass is audited).",
		addRule: "Add rule",
		preview: "Preview rules",
		saveAll: "Save all changes",
		empty: "No PII rules configured yet",
		colField: "Field code",
		colMode: "Mode",
		colExample: "Example",
		colNote: "Note",
		colOperation: "Actions",
		actDelete: "Delete",
		modeKeep: "Keep raw value (default)",
		modeMask: "Mask",
		modeRedact: "Placeholder",
		modePseudonym: "Project-deterministic pseudonym",
		modeHash: "SHA-256 hash (12 hex)",
		modeSuppress: "Suppress field",
		modeGeneralise: "Bucket / generalise",
		previewMissingInput: "Please fill in field and mode.",
		draftMissingFieldCode: "New rules must have a field code.",
		saveSummary: "Saved {saved} · deleted {deleted}",
	},
	analytics: {
		overviewTitle: "Analytics overview",
		datasetTitle: "Datasets",
		encodingTitle: "Field encoding",
		selectionTitle: "Field selection",
		algorithmTitle: "Algorithm runs",
		reportTitle: "Statistical report",
		researchOverviewTitle: "Research overview",
		libraryTitle: "Library",
		topicsTitle: "Topic recommendations",
		workbenchTitle: "Workbench",
		refresh: "Refresh",
		empty: "No analytics data yet",
		statSamples: "Samples",
		statFields: "Fields",
		statAnalyses: "Analyses",
		recentAnalyses: "Recent analyses",
		colName: "Name",
		colType: "Type",
		colCreatedAt: "Created",
		colOperation: "Actions",
		actView: "View",
		viewDetail: "View details",
		typeAlgorithm: "Algorithm",
		typeReport: "Report",
		errorProject: "Project not found",
		errorFetch: "Failed to load data",
	},
	clinic: {
		operationOverview: "Operations overview",
		appointments: "Appointment add-ons",
		checkins: "Check-ins",
		chatHistory: "Chat history",
		users: "Outpatient users",
		refresh: "Refresh",
		today: "Today",
		last7d: "Last 7d",
		last30d: "Last 30d",
		last90d: "Last 90d",
		custom: "Custom",
		dateSep: "to",
		startDate: "Start",
		endDate: "End",
		kpiTotalUsers: "Total users",
		kpiNewUsers: "New users (period)",
		kpiActiveUsers: "Active users",
		kpiDeactivated: "Deactivated accounts",
		kpiSnapshot: "Snapshot",
		kpiMessages: "Messages (period)",
		kpiConversations: "Conversations (period)",
		kpiUploads: "Uploads (period)",
		kpiFollowupMessages: "Follow-up messages (period)",
		recentRegistrations: "Recent registrations",
	},
	discern: {
		title: "AI recognition",
		uploader: "Uploaded by:",
		userType: "User type:",
		identifyStatus: "OCR status:",
		confirmStatus: "Review status:",
		input: "Type here",
		select: "Select…",
		userDoctor: "Doctor",
		userPatient: "Patient",
		userSys: "Admin",
		statusUnfinished: "Pending",
		statusFinished: "Done",
		statusPending: "Pending review",
		statusConfirmed: "Reviewed",
		searchBtn: "Search",
		resetBtn: "Reset",
		qrCode: "QR code",
		batchUpload: "Batch upload",
		colIndex: "No.",
		colUploader: "Uploaded by",
		colUserType: "User type",
		colProject: "Project",
		colFileCount: "Files",
		colUploadTime: "Uploaded",
		colIdentifyStatus: "OCR",
		colIdentifyTime: "OCR time",
		colConfirmStatus: "Review",
		colConfirmUser: "Reviewer",
		colConfirmTime: "Reviewed",
		colOperation: "Actions",
		actView: "View",
		actConfirm: "Review",
		viewTitle: "AI recognition detail",
		batchUploadTitle: "Batch upload",
		dropFiles: "Drop files here, or",
		clickUpload: "click to upload",
		fileTip: "JPG/PNG only, max 10MB per file",
		startUpload: "Upload",
	},
	governance: {
		title: "Approval inbox",
		myTitle: "My requests",
		refresh: "Refresh",
		colId: "Request ID",
		colType: "Type",
		colRequester: "Requester",
		colCreatedAt: "Submitted",
		colStatus: "Status",
		colOperation: "Actions",
		actView: "View",
		actApprove: "Approve",
		actReject: "Reject",
		statusPending: "Pending",
		statusApproved: "Approved",
		statusRejected: "Rejected",
		statusCancelled: "Cancelled",
		drawerTitle: "Request detail",
		approve: "Approve",
		reject: "Reject",
		comment: "Comment",
		commentPh: "Enter your decision rationale",
		noPendingStep: "No pending approval step",
		emptyCommentConfirm: "A rationale is recommended when rejecting. Submit with an empty comment?",
		confirmTitle: "Confirm",
		toastApproved: "Approved",
		toastRejected: "Rejected",
		quickConfirmBody: "{action} request #{id}?",
		quickConfirmTitle: "Confirm action",
	},

	basicInfo: {
		doctor: "Attending doctor",
		maskedDoctor: "*** Doctor",
		hospital: "Institution",
		maskedHospital: "**** Hospital",
		input: "Type here",
		enrollDate: "Enrollment date",
		select: "Select…",
		status: "Status",
		diagnosis: "Diagnosis",
		diagnosisPh: "Enter diagnosis",
	},
	patientInfo: {
		patientNo: "Patient ID",
		randomNo: "Random ID",
		name: "Name",
		gender: "Gender",
		age: "Age",
		ageUnit: "yrs",
		dob: "Date of birth",
		phone: "Phone",
		idNumber: "ID number",
		project: "Project",
		enrollDate: "Enrolled",
		status: "Status",
		doctor: "Attending doctor",
		hospital: "Institution",
	},
	followupRecord: {
		recordTitle: "Follow-up records",
		newRecord: "New visit",
		emptyHint: "No follow-up records yet",
		actView: "View",
		actEdit: "Edit",
		actDelete: "Delete",
		visitName: "Visit",
		dueDate: "Due",
		actualDate: "Completed",
		statusPending: "Pending",
		statusOverdue: "Overdue",
		statusDone: "Done",
		confirmCancel: "Cancel this visit?",
		menuSelect: "Pick template",
		menuDelete: "Delete template",
		menuAdd: "Add ad-hoc visit",
		dialogSelectTitle: "Pick a follow-up plan template",
		dialogAddTitle: "Add ad-hoc visit",
		fieldProjectName: "Project:",
		fieldTemplate: "Template:",
		fieldStart: "Start date:",
		select: "Select…",
		datePh: "Pick a date",
		ruleTemplate: "Pick a template",
		ruleStart: "Pick a start date",
		generatePlan: "Generate plan",
		confirmDelete: "This cannot be undone. Delete?",
		dialogTipTitle: "Confirm",
		deleteSuccess: "Deleted",
	},
	upgradation: {
		dialogTitle: "Upgrade plan",
		selectLevel: "Select plan",
		level: "Plan",
		duration: "Duration",
		monthly: "{n} month(s)",
		yearly: "{n} year(s)",
		price: "Price",
		discount: "Verified users save 50%",
		payNow: "Pay now",
		paySuccess: "Payment successful",
		payFailed: "Payment failed",
		qrTip: "Scan with WeChat to pay",
	},
	fileUpload: {
		click: "Click to upload",
		drop: "or drop files here",
		tip: "JPG / PNG / PDF supported",
		preview: "Preview",
		download: "Download",
		remove: "Remove",
		removeConfirm: "Remove this file?",
		uploading: "Uploading…",
		uploaded: "Uploaded",
		uploadFailed: "Upload failed",
		uploadFailedWithReason: "Upload rejected: {reason}",
		duplicateRejected: "Duplicate file rejected — this file has already been uploaded for this patient.",
		exceed: "Too many files",
		view: "View",
		upload: "Upload",
		dialogUploadTitle: "Upload Files",
		dialogViewTitle: "View Files",
		cancelUpload: "Cancel Upload",
		selectFile: "Choose File",
		dragHint: "Drag files here, or",
		clickToSelect: "click to select",
		aiOcr: "AI Recognition",
		submitted: "Submitted",
		selectAll: "Select All",
		selected: "{n} selected",
		emptyData: "No data",
	},
	patientList: {
		patientNoOrName: "Patient ID / name:",
		enrollDate: "Enrolled:",
		startDate: "Start",
		endDate: "End",
		center: "Centre:",
		searchPlaceholder: "Type here",
		searchKeyword: "Type to search",
		searchBtn: "Search",
		resetBtn: "Reset",
		colIndex: "No.",
		colCompleteness: "Completeness",
		colOperation: "Actions",
		dragReorderTip: "Drag to reorder columns (this browser only)",
		actDetail: "Patient",
		actFollowup: "Follow-up",
		actImaging: "Imaging",
		actTimeSeries: "Time series",
		actDelete: "Delete",
		deleteSuccess: "Deleted",
		deleteConfirm: "Delete this patient record? This cannot be undone.",
		deleteTitle: "Confirm",
		add: "Add patient",
		export: "Export",
		batchEnroll: "Batch enroll",
		import: "Import",
		advancedFilter: "Advanced filter",
		colPatientNo: "Patient ID",
		colName: "Name",
		colGender: "Gender",
		colBirth: "Date of birth",
		colAge: "Age",
		colEnrollDate: "Enrolled",
		colCenter: "Centre",
		genderMale: "Male",
		genderFemale: "Female",
		genderUnknown: "Unknown",
		ageYears: "yrs",
		viewSource: "Source",
	},
	patientDetail: {
		add: "Add patient",
		edit: "Edit patient",
		fileView: "Patient file view",
		basicInfo: "Basic info",
		save: "Save",
		saveDraft: "Save draft",
		discard: "Discard changes",
		nextForm: "Next",
		prevForm: "Back",
		visitRecords: "Visits",
		followups: "Follow-ups",
		documents: "Imaging / files",
		newVisit: "New visit",
		fieldRequired: "Required",
	},
	retrieval: {
		title: "Data retrieval",
		exportTitle: "Data retrieval — export",
		searchPlaceholder: "Type to search",
		newQuery: "New query",
		runQuery: "Run query",
		exportResult: "Export results",
		conditions: "Filters",
		results: "Results",
		colIndex: "No.",
		colName: "Query name",
		colCreatedAt: "Created",
		colOperation: "Actions",
		actView: "View",
		actEdit: "Edit",
		actDelete: "Delete",
		actExport: "Export",
		actRun: "Run",
		deleteGroup: "Delete group",
		selectValues: "Select value(s)",
		enterValue: "Enter a value",
		fieldTreeFailed: "Couldn't load the field list",
		selectAnalysisField: "Pick a field to analyse first",
		condition: {
			is: "Equals",
			ne: "Not equals",
			gt: "Greater than",
			gte: "Greater than or equal",
			lt: "Less than",
			lte: "Less than or equal",
			regex: "Fuzzy match",
			exists: "Has value",
			in: "In list",
			nin: "Not in list",
			all: "Contains all",
			yes: "Yes",
			no: "No",
			and: "Match all conditions",
			or: "Match any condition",
			nor: "Match none of the conditions",
		},
		stats: {
			title: "Result statistics",
			chart: "Chart",
			chartTypePlaceholder: "Select chart type",
			startDate: "Start date",
			endDate: "End date",
			startDatePlaceholder: "Select start date",
			endDatePlaceholder: "Select end date",
			barChart: "Bar chart",
			pieChart: "Pie chart",
			sampleSize: "Sample size",
			max: "Max",
			min: "Min",
			median: "Median",
			avg: "Mean",
		},
		exportPage: {
			searchConditions: "Search conditions",
			saveAsTemplate: "Save as template",
			resultList: "Search results",
			colPatientNo: "Patient ID",
			colPatientName: "Patient name",
			colEnrollmentDate: "Enrollment date",
			colAge: "Age",
			colBirthday: "Date of birth",
			colDoctor: "Attending doctor",
			colEnrollmentStatus: "Enrollment status",
			colLastUpdated: "Last updated",
			colUpdatedBy: "Updated by",
			colDataManage: "Data",
			patientDetail: "Patient details",
			followUpDetail: "Follow-up details",
			templateNamePlaceholder: "Enter a template name",
			templateNameRequired: "Please enter a template name",
			templateSaved: "Template saved",
			joinSubProject: "Enrol into sub-project",
			existingSubProjects: "Existing sub-projects",
			subProjectName: "Sub-project name",
			projectStartDate: "Project start date",
			projectEndDate: "Project end date",
			enrolledCount: "Enrolled",
			actEnrol: "Enrol",
			addSubProject: "Add sub-project",
			basicInfo: "Basic info",
			rootProjectName: "Root project name",
			projectLeader: "Project lead",
			leaderUnit: "Lead's unit",
			projectGoal: "Project goal",
			selectSubProject: "Please select a sub-project",
		},
		exportDialog: {
			title: "Data export",
			exportAll: "Export all forms and models",
			exportPartial: "Export selected forms and models",
			selectForms: "Select the forms and models to export",
			approvalConfirm: "Exports from this project require approval before download. Submit an export request?",
			approvalTitle: "Approval required",
			submitRequest: "Submit request",
			requestId: "Request ID",
			status: "Status",
			requestPending: "Your export request is awaiting reviewer approval. Track its progress in My Requests.",
			requestSubmitted: "Export request submitted",
			goToMyRequests: "Go to My Requests",
		},
	},
	analysis: {
		title: "Data analysis",
		runAnalysis: "Run analysis",
		results: "Results",
		exportResult: "Export report",
		emptyHint: "Pick fields first, then run the analysis.",
	},
	projectManage: {
		title: "Project list",
		searchPlaceholder: "Search by project name",
		clearModelCache: "Clear model cache",
		clearModelCacheConfirm:
			"Clear all model caches? Users will see a one-off slowdown on the first load afterwards.",
		clearModelCacheTip: "Heads up",
		clearModelCacheSuccess: "Cache cleared. {n} entries removed.",
		newProject: "New project",
		colProjectId: "Project ID",
		colProjectName: "Project",
		colProjectLeader: "Project lead",
		colProjectTerm: "Term",
		colFollowupData: "Follow-up data",
		colViewInfo: "View info",
		colMainCenter: "Lead centre",
		colOperation: "Actions",
		actEdit: "Edit",
		actScene: "Scenario",
		actDatabase: "Database config",
		actFollowup: "Follow-up config",
		actPermissions: "Members & permissions",
		actSubCenter: "Sub-centres",
		actSubProject: "Sub-projects",
		actSchema: "Initial schema",
		actAgent: "Agent config",
		actMetadataHistory: "Metadata history",
		actLifecycle: "Lifecycle & retention",
		actPiiRule: "PII rule registry",
		grpSetup: "Setup",
		grpData: "Data",
		grpGovernance: "Governance",
		grpStructure: "Structure",
		lostFollowups: "Orphaned follow-up plans: {n}",
		fixData: "Fix data",
		patientCount: "Patients: {p}; view rows: {v};",
		patientViewMismatch: "--- mismatch ---",
		buildStatus: "Build status: {s};",
		buildBusy: "Building view…",
		buildIdle: "Idle",
		startTime: "Started: {t};",
		endTime: "Ended: {t};",
		execResult: "Result: {r};",
		execSuccess: "Success",
		execFailed: "Failed",
		rebuildView: "Rebuild view",
		appendView: "Patch view",
		recalcCompleteness: "Recalc completeness",
		opSent: "Request submitted",
		recalcDone: "Recalc complete. {n} patients processed.",
		dialogBaseTitle: "Basic info",
		dialogSceneTitle: "Scenario",
		fieldProjectName: "Project name",
		fieldProjectCode: "Project code",
		fieldProjectLeader: "Project lead",
		fieldLeadCenter: "Lead unit",
		fieldStartDate: "Start date",
		fieldEndDate: "End date",
		fieldTarget: "Goals",
		fieldLeaderUnit: "Lead unit",
		fieldCompanyLogo: "Company logo (horizontal)",
		fieldSquareLogo: "Square logo (icon)",
		placeholderSelect: "Select…",
		fieldSpecialty: "Specialty",
		fieldDisease: "Disease",
		fieldSoftwareEnv: "Software surfaces",
		envWeb: "Web",
		envDoctor: "Doctor mini-app",
		envPatient: "Patient mini-app",
		fieldLoginUrl: "Project login URL",
		fieldLoginName: "Project login name",
		fieldLoginImage: "Project login image",
		searchPlaceholderRemote: "Type to search",
	},
	equity: {
		accountInfo: "Account info",
		username: "Username:",
		realNameAuth: "Real-name verification:",
		modify: "Edit",
		notAuthHint: "Real-name verification incomplete — half-price discount unavailable.",
		goAuth: "Verify now",
		levelExpire: "Plan valid until: {date}",
		upgrade: "Upgrade plan",
		memberRights: "Plan benefits",
		categoryProjectMgmt: "Project management",
		categoryAiCollect: "AI data capture",
		categoryAiAnalysis: "AI data analysis",
		categoryIp: "IP services",
		categoryResearch: "Research services",
		rightCreateProject: "Create projects",
		rightCustomForm: "Custom forms",
		rightFollowup: "Follow-up management",
		rightEnrollment: "Enrollment status",
		rightSubProject: "Sub-projects",
		rightUnivariate: "Univariate statistics",
		rightSearch: "Data retrieval",
		rightExport: "Data export",
		rightHistorical: "Historical re-enrollment",
		rightAutoEnroll: "Auto eligibility check",
		rightCrfGen: "Auto-generate CRFs",
		rightCrfFill: "Auto-fill CRFs",
		rightPathology: "Auto-generate pathology reports",
		rightFollowupChat: "Interactive follow-up",
		rightAiSearch: "AI search",
		rightAiStat: "AI statistics",
		rightAiExport: "AI filtered export",
		rightAiEnroll: "AI eligibility",
		rightIpFile: "IP filing",
		rightJointProject: "Joint research filing",
		basicMember: "Basic plan",
		smartMember: "Smart plan",
		joint1Software: "1 free joint copyright filing",
		joint2Software: "2 free independent copyright filings",
		jointAiProject: "Eligible to join the AI medical research consortium",
		currentLevel: "Current plan",
		dialogAuthTitle: "Identity verification",
	},
	order: {
		searchPlaceholder: "Search by order number",
		orderList: "Orders",
		colIndex: "No.",
		colOrderNo: "Order #",
		colPaymentTime: "Paid at",
		colPaymentFees: "Amount",
		colPaymentMethod: "Method",
		methodWechat: "WeChat",
		colContent: "Item",
		colStatus: "Status",
		colInvoiceStatus: "Invoice",
		colOperation: "Actions",
		actInvoice: "Issue invoice",
		statusCreated: "Awaiting payment",
		statusPayed: "Paid",
		statusUsed: "Redeemed",
		invoiceNotIssued: "Not issued",
		invoiceIssued: "Issued",
		dialogTitle: "Invoice details",
		titleSection: "Header",
		fieldAmount: "Invoice amount",
		amountUnit: "RMB",
		fieldHeaderType: "Header type",
		typePersonal: "Personal / non-enterprise",
		typeEnterprise: "Enterprise",
		fieldInvoiceType: "Invoice type",
		invoiceTypeValue: "Standard VAT e-invoice",
		fieldHeader: "Invoice header",
		placeholderInput: "Type here",
		placeholderHeader: "Enter the invoice header",
		fieldTaxNumber: "Tax ID",
		placeholderTaxNumber: "Enter a 15–20 character tax ID",
	},
	subProjectManage: {
		title: "Sub-project list",
		breadCrumb: "Project management / {parent}",
		newSubProject: "New sub-project",
		searchPlaceholder: "Search by sub-project name",
	},
	projectList: {
		projectCode: "Project Code",
		centerCount: "Number of Centres",
		patientCount: "Enrolled Patients",
		subProjects: "Sub-projects",
		openProject: "Open Project",
		emptyHint: "You don't have any projects yet — create one to get started.",
		createProject: "Create Project",
		noticeSystem: "System Notice",
		noticeOcr: "OCR Recognition",
		noticeChallenge: "Data Challenge",
	},
	projectHead: {
		projectName: "Project",
		rootProjectName: "Root project",
		subProjectName: "Sub-project",
		parentProject: "Parent cohort",
		specialty: "Specialty",
		disease: "Disease",
		formConfig: "Form configuration",
		followUpConfig: "Follow-up configuration",
	},
	home: {
		leadCentre: "Lead Centre",
		maskedHospital: "**** Hospital",
		projectLead: "Project Lead",
		projectTerm: "Project Term",
		pendingReply: "Pending Replies",
		clickToReply: "Click to view & reply →",
		totalCases: "Total Cases",
		newCasesThisMonth: "New Cases (This Month)",
		avgCompleteness: "Avg. Completeness",
		followUpOverdue: "Follow-ups Overdue",
		view: "View",
		notifications: "Project Notifications",
		index: "No.",
		notificationType: "Type",
		notificationContent: "Content",
		count: "Count",
		enrollmentTrend: "Enrollment",
		genderRatio: "Gender",
		ageDistribution: "Age Distribution",
	},
};
